var map = {
	"./bg.jpg": "86d5",
	"./data/GDP_high.csv": "ae61",
	"./data/GDP_low.csv": "6901",
	"./data/GDP_mid.csv": "7eb1",
	"./data/happy_df_cluster": "0842",
	"./data/happy_df_cluster.json": "0842",
	"./data/happy_df_cluster_0": "7c94",
	"./data/happy_df_cluster_0.json": "7c94",
	"./data/happy_df_cluster_1": "5357",
	"./data/happy_df_cluster_1.json": "5357",
	"./data/happy_df_cluster_2": "69e9",
	"./data/happy_df_cluster_2.json": "69e9",
	"./data/happy_df_without_rank.csv": "5334",
	"./data/map_result_left_join": "5768",
	"./data/map_result_left_join.json": "5768",
	"./data/map_topo": "330d",
	"./data/map_topo.json": "330d",
	"./happy_high.png": "aa93",
	"./happy_low.png": "3210",
	"./happy_mid.png": "3513",
	"./heatmap_all.png": "325a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";